import { CommonModule } from '@angular/common';
import { booleanAttribute, ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'la-panel-content',
  styleUrls: ['./panel-content.component.scss'],
  templateUrl: './panel-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule, MatButtonModule, MatIconModule, MatDividerModule],
})
export class PanelContentComponent {
  @Input() title?: string;
  @Input() subtitle?: string;
  @Input() back = true;
  @Input() link = '../';
  @Input() backButton = false;

  @HostBinding('class.no-padding') @Input({ transform: booleanAttribute }) noPadding = false;

  @Output() closing = new EventEmitter();
}
